// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10tO7","toggleWrap":"styles_toggleWrap__11KVS","content":"styles_content__1P-r5","selectAreaCode":"styles_selectAreaCode__38sMx"};